import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL: string = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_ANON_KEY: string = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (typeof SUPABASE_URL !== 'string' || typeof SUPABASE_ANON_KEY !== 'string') {
  throw new Error("Missing Supabase environment variables");
}

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    db: {
      schema: 'public',
    },
    global: {
      fetch: (url, options = {}) => {
        // Remove timeout for function calls by removing any signal
        const urlString = typeof url === 'string' ? url : url.toString();
        if (urlString.includes('/functions/v1/')) {
          const { signal, ...restOptions } = options;
          return fetch(url, restOptions);
        }
        return fetch(url, options);
      },
    },
  }
);
